import React, { Component } from "react"
import { regexNumber, isArrayEqual } from "../utils";

const defaultConfig = {
    separator: '-',
    inputClassName: 'form-control',
    inputStyle: {
        width: '12%',
        height: 50,
        display: 'inline-block',
        fontSize: 18,
        textAlign: 'center',
        minWidth: 38,
    },
    containerStyle: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    inputsAmount: 6,
},
    LEFT_ARROW = 37,
    RIGHT_ARROW = 39

class OTPInput extends Component {

    state = {
        values: [],
    }

    componentWillMount() {
        let initialStte = []
        for (var i = 0; i < (this.props.inputsAmount || defaultConfig.inputsAmount); i++) {
            initialStte.push('')
        }
        this.setState({ values: initialStte })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.onChange && !isArrayEqual(prevState.values, this.state.values)) {
            this.props.onChange(this.getOTPValues())
        }
    }

    getOTPValues() {
        let result = '';
        (this.state.values).forEach(value => {
            result += value
        })
        return result
    }

    onInputChange(value, index) {
        if (regexNumber(value)) {
            let newValues = (this.state.values).slice()
            newValues[index] = value
            this.setState({ values: newValues })
            this.focusNextInput(index)
        } else if (value == '') {
            let newValues = (this.state.values).slice()
            newValues[index] = value
            this.setState({ values: newValues })
            this.focusPrevInput(index)
        }
    }

    focusNextInput(index) {
        if (index != (this.props.inputsAmount || defaultConfig.inputsAmount) - 1) {
            this[index + 1].focus()
        }
    }

    focusPrevInput(index) {
        if (index != 0) {
            this[index - 1].focus()
        }
    }

    getInput(inputClassName, inputStyle, index) {
        return (
            <input
                className={inputClassName || defaultConfig.inputClassName}
                style={{ ...defaultConfig.inputStyle, ...inputStyle }}
                value={this.state.values[index]}
                autoFocus={index == 0}
                onChange={(e) => {
                    this.onInputChange(e.target.value, index)
                }}
                onFocus={(e) => {
                    e.target.select()
                }}
                onKeyDown={(e) => {
                    switch (e.which) {
                        case LEFT_ARROW:
                            e.preventDefault()
                            this.focusPrevInput(index)
                            break
                        case RIGHT_ARROW:
                            e.preventDefault()
                            this.focusNextInput(index)
                            break
                        default:
                            break
                    }
                }}
                maxLength={1}
                ref={(input) => { this[index] = input; }}
                key={index}
            />
        )
    }

    renderInputs(
        inputClassName,
        inputStyle,
        separator,
        separatorClassName,
        separatorStyle,
        amount
    ) {
        let result = []
        for (var i = 0; i < amount; i++) {
            if (i === amount - 1) {
                result.push(
                    this.getInput(inputClassName, inputStyle, i)
                )
            } else {
                result.push(
                    this.getInput(inputClassName, inputStyle, i)
                )
                result.push(
                    <span
                        className={separatorClassName}
                        style={{ ...separatorStyle }}
                        key={i + 'separator'}>
                        {separator || defaultConfig.separator}
                    </span>
                )
            }
        }
        return result
    }

    render() {
        const {
            containerClassName,
            containerStyle,
            inputClassName,
            inputStyle,
            separator,
            separatorClassName,
            separatorStyle,
            inputsAmount,
        } = this.props
        return (
            <div
                className={containerClassName}
                style={{ ...defaultConfig.containerStyle, ...containerStyle }}>
                {this.renderInputs(
                    inputClassName,
                    inputStyle,
                    separator,
                    separatorClassName,
                    separatorStyle,
                    inputsAmount || defaultConfig.inputsAmount,
                )}
            </div>
        )
    }
}
export default OTPInput


// WEBPACK FOOTER //
// ./src/components/otpInput.js